import script from "./LanguageTranslations.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageTranslations.vue?vue&type=script&setup=true&lang=js"

import "./LanguageTranslations.vue?vue&type=style&index=0&id=6b50f355&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b50f355"]])

export default __exports__